<template>
  <div class="row">
    <div class="col-sm-6">
      <card class="stacked-form">
        <cost-center-form
          @submit="submit"
          :init-cost-center="{}"
          :val-errors="valErrors"
          submit-text="Erstellen"
        />
      </card>
    </div>
  </div>
</template>

<script>
import CostCenterForm from './cost-center-form'

export default {
  components: { CostCenterForm },
  data () {
    return {
      valErrors: []
    }
  },
  methods: {
    async submit (costCenter) {
      await this.initCsrf()

      this.valErrors = []
      this.$http.post('cost_centers', costCenter).then(({ data }) => {
        this.$notify({
          message: 'Kostenstelle erfolgreich erstellt.',
          type: 'success'
        })
        this.$router.push('/cost_centers')
      }).catch(({ response }) => { this.valErrors = response.data.errors })
    }
  }
}
</script>

<style>
</style>
